package com.vizio.redwolf.utils

expect val platform: Platform

sealed class Platform(val apiName: String) {
    object Android: Platform("jvm")
    object iOS: Platform("ios")
    object JS: Platform("js")
}